export const searchApplicant = `
    query searchApplicant($employeeId: String!) {
        searchApplicant(employeeId: $employeeId) {
                applicantEmployeeId
                reviewerEmployeeId
                programId
                term
                firstName
                lastName
                status
                type  
        }
    }
`;

export const searchReviewer = `
    query searchReviewer($employeeId: String!) {
        searchReviewer(employeeId: $employeeId) {
                applicantEmployeeId
                reviewerEmployeeId
                programId
                term
                firstName
                lastName
                status
                type
        }
    }
`;

export const getStudentRequestReasons = `
    query getStudentRequestReasons {
        getStudentRequestReasons {
            KEY
            LABEL
        }
    }
`;

export const personSearch = `
    query personSearch($input: PersonSearchInput!, $export: Boolean) {
        personSearch(input: $input, export: $export) {
            columns {
                field
                flex
                headerName
                renderCell
                width
                default
                detailHeaderName
            }
            results
            totalCount
            signedUrl
        }
    }
`;

export const searchForAllData = `
    query searchForAllData($input: SearchAllDataInput!, $export: Boolean) {
        searchForAllData(input: $input, export: $export) {
            columns {
                field
                flex
                headerName
                renderCell
                width
                default
                detailHeaderName
            }
            results
            totalCount
            signedUrl
        }
    }
`;

export const getDistinctValuesForSearch = `
    query getDistinctValuesForSearch($attribute: String!) {
        getDistinctValuesForSearch(attribute: $attribute)
    }
`;

export const changeWorkflow = `
    mutation changeWorkflow($input: ChangeWorkflowInput!) {
        changeWorkflow(input: $input) {
            status
            executionId
            message
        }
    }
`;

export const changeRequested = `
    mutation changeRequested($input: ChangeRequestedInput!) {
        changeRequested(input: $input) {
            status
            successDetails
            errorDetails
        }
    }
`;

export const getProgramResolveOptions = `
    query getProgramResolveOptions {
        getProgramResolveOptions {
            key
            value
            displayName
            sort
        }
    }
`;

export const getAdminOverrideReasons = `
    query getAdminOverrideReasons {
        getAdminOverrideReasons
    }
`;

export const overrideWorkflowDecision = `
    mutation overrideWorkflowDecision($input: OverrideWorkflowDecisionInput!) {
        overrideWorkflowDecision(input: $input) {
            status
            executionId
            message
        }
    }
`;

export const getChangeWorkflowOptions = `
    query getProgramResolveOptions {
        getChangeWorkflowOptions {
            key
            value
        }
    }
`